"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addEventListener = void 0;
var events_1 = __importDefault(require("../../util/dom-helpers/events"));
function addEventListener(node, event, handler, capture) {
  if (capture === void 0) {
    capture = false;
  }
  events_1.default.on(node, event, handler, capture);
  return {
    remove: function remove() {
      events_1.default.off(node, event, handler, capture);
    }
  };
}
exports.addEventListener = addEventListener;